import React, { useEffect, useState } from "react";
import {
  Button,
  DocumentsList,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";
import {
  dateFormator,
  getValueByKey,
  mapTableRows,
} from "../../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import { getAllTaxFormDocumentsStart } from "../../../../../redux/slices/document/documentSlice";
import { transformFiles } from "../../../../../utils/transformFiles";

const W4Form = () => {
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );
  const documents = useSelector((state) => state.documents.taxForm) || {};
  const tableData = documents?.w4Form || [];
  const columns = [
    {
      key: "payFrequency",
      label: "Pay Frequency",
      sortable: false,
      render: (row) => getValueByKey(row?.payFrequency, "TimesheetCycles"),
    },

    {
      key: "suiState",
      label: "SUI State",
      sortable: false,
      render: (row) => row?.state?.sui || "-",
    },

    {
      key: "federalFilingStatus",
      label: "Federal Filing Status",
      sortable: false,
      render: (row) =>
        getValueByKey(row?.federalFilingStatus, "FederalFilingStatus"),
    },

    {
      key: "payrollWHState",
      label: "Payroll WH State",
      sortable: false,
      render: (row) => row?.state?.payrollWh,
    },

    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags tag={getValueByKey(row?.status, "RecordStatus")} />
      ),
      sortable: false,
    },
    {
      key: "effectiveDate",
      label: "Effective Date",
      render: (row) => dateFormator(row?.effectiveDate, "month-day-year"),
      sortable: false,
    },
    {
      key: "inactiveDate",
      label: "Inactive Date",
      render: (row) => dateFormator(row?.inactiveDate, "month-day-year"),
      sortable: false,
    },
    {
      key: "documents",
      label: "Attachments",
      render: (row) => {
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              row?.documents?.length > 0 && "cursor-pointer"
            }`}
            onClick={
              transformFiles(row?.documents || []).length > 0
                ? () =>
                    handelDocumetsModal(transformFiles(row?.documents || []))
                : () => {}
            }
          >
            <span className={`${row?.documents.length > 0 && "text-linkblue"}`}>
              {transformFiles(row?.documents).length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit"
            size="xs"
            variant="text"
            color="black"
          />
          {/* <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
            /> */}
        </div>
      ),
      sortable: false,
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsModalOpen(true);
  };
  console.log("selectedDocuments", selectedDocuments);
  /////// Load data from redux store
  useEffect(() => {
    if (employeeProfileUiid) {
      dispatch(
        getAllTaxFormDocumentsStart({
          tab: "w4FormTab",
          ret: "w4Form",
          coll: "EmpTaxform",
          fil: {
            employeeId: {
              type: "NONE",
              value: employeeProfileUiid,
            },
            taxType: {
              type: "NONE",
              value: 1,
            },
          },
          ref: "Document",
        })
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_documents_w4`} rows={mappedRows} columns={columns} hideToolBar />

      {/* //Documetn List */}
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default W4Form;
